<template>

    <section id="home-slide-medias" class="p-lg-5 m-0 text-start container-fluid">
        <div class="flex justify-around">
            <h1 class="c-primary">{{ gettext("Médias") }}</h1>
        </div>

    <carousel :items-to-show="1">

        <slide class="slide">
            <div class="carousel__item row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="rounded-circle" src="/static/img/lenouveleco.svg" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    Les legaltechs s’emparent de plus en plus des enjeux liés à la responsabilité sociétale des entreprises (RSE).
                    Pour Inès Hamy, CEO d’Octolo, la démarche d’adopter une raison d’être et de devenir une société à mission fait de son entreprise “un objet éthique, et pas seulement économique”.
                    La start-up s’est donc fixé plusieurs objectifs sociaux, sociétaux et environnementaux, ...
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.lenouveleconomiste.fr/lesdossiers/legaltech-et-regtech-tracent-leur-voie/">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("Le nouvel Economiste - Les legaltech s’emparent des enjeux de RSE") }}</small>
                </div>
            </div>
        </slide>


        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img src="/static/img/maddyness.svg" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    La RSE serait-elle une des clés différenciantes pour les legaltechs et se rendre attractive aux yeux de potentiels candidats?
                    Découvrez l’ingéniosité des politiques RH mises en place par les meilleures startups du secteur recensées dans le Baromètre des Legaltechs françaises.
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.maddyness.com/2023/02/21/rse-recrutement-legaltechs/">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("MADDYNESS - La RSE un levier différenciant pour le recrutement dans les legaltechs ?") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="rounded-circle" src="/static/img/CHALLENGES.jpg" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    Conçue pour les dirigeants d’entreprises et d’associations,
                    les avocats, les experts-comptables et les fonds d’investissement,
                    la legaltech Octolo propose une plateforme collaborative de gestion de l’actionnariat.
                    Un outil sécurisé et ergonomique, 100% en ligne, aux nombreuses fonctionnalités :
                    organisation de réunions des organes dirigeants, registres digitalisés, table de capitalisation, dataroom intelligente...
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.challenges.fr/economie/octolo-toute-la-gestion-de-l-actionnariat-en-quelques-clics_749389">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("Challenges") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/logo/homepage/banqueterritoires.png" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    La RSE (responsabilité sociale des entreprises) n’est pas l’apanage des grands groupes.
                    De nombreuses LegalTechs s’engagent également sur cette voie, avec conviction et détermination,
                    même si l’argument ne fait pas, à ce jour, une (réelle) différence au niveau de leur business.
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.banquedesterritoires.fr/legaltech/actualites/la-legaltech-s-empare-aussi-des-enjeux-RSE">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("La banque des territoires") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/FRENCHIOT.png" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    Octolo.tech sélectionnée parmi les start-up prometteuses de la communauté FRENCH IoT (La Poste) 2021...
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.jaimelesstartups.fr/news/octolo-rejoint-la-communaute-french-iot/">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("J'aime les startups") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/BSMART.png" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    Mardi 27 avril 2021, Cécilia Severi reçoit dans LE LAB Inès Hamy (Octolo). Octolo :
                    Lancement d'Octolo, solution de gestion de l'actionnariat et des associations.
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.bsmart.fr/video/679,37-le-lab-octolo">{{ gettext("Voir l'interview") }}</a>
                    </p>
                    <small>{{ gettext("BSMART") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/logo/homepage/banqueterritoires.png" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    Une jeune entrepreneuse dans un secteur jeune :
                    Inès Hamy explique ci-après comment son parcours l’a amené à créer Octolo.tech,
                    une solution dédiée au secrétariat général et à la gouvernance, et partage sa vision du secteur LegalTech.
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.banquedesterritoires.fr/legaltech/actualites/interview-ines-hamy-co-fondatrice-doctolotech">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("La banque des territoires") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/charlotte.jpeg" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    Tout a commencé avec un pain point « simple » à résoudre :
                    supprimer la lourdeur de l’organisation d’une AG. Côté gestionnaire ?
                    Il convoque, suit les votes en direct et génère des PV automatiquement.
                    Côté actionnaires ? Ils participent, répondent et votent, en avance ou en direct.
                    Mais Inès Hamy, Ceo de Octolo, ne s’est pas...
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://lejournaldecharlotte.com/podcast/5-octolo-le-poulpe-qui-digitalise-la-gestion-de-lactionnariat/">{{ gettext("Écouter le podcast") }}</a>
                    </p>
                    <small>{{ gettext("Le journal de charlotte") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/jaimelesstartups.png" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    La legaltech Octolo est une plateforme collaborative de gestion de
                    l'actionnariat et du secrétariat juridique des entreprises et associations.
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.jaimelesstartups.fr/octolo-platforme-saas-de-digitalisation-du-secretariat-juridique-des-entreprises-et-associations/">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("J'aime les startups") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/VILLAGE.png" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    A l'heure où les mots « innovation » et « legaltech » sont présents dans tous les discours relatifs au développement numérique
                    (ou digital) des entreprises et professions du droit, de nombreuses startup (...)
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href=" https://www.village-justice.com/articles/Les-start-up-droit,18224.html?societe=Octolo#annuaire-legaltech">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("Le village de la Justice") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/logo/homepage/banqueterritoires.png" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    En résonnance avec les fondamentaux du développement durable, les politiques RSE des entreprises reposent sur
                    des actions au niveau social, sociétal et environnemental. Il en va de même dans la LegalTech ou bon
                    nombre de LegalTechs déploient une politique RSE au niveau social, sociétal, environnemental et éthique.
                    Tour d’horizon d’exemples d'actions RSE déployées par des legaltech avec Manon Filhol, responsable RH et RSE chez Data Legal Drive, Inès Hamy,
                    co-fondatrice d'Octolo et Louis Larret-Chahine, cofondateur de Predictice...
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.banquedesterritoires.fr/legaltech/actualites/les-bonnes-pratiques-rse-de-la-legaltech">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("La banque des territoires") }}</small>
                </div>
            </div>
        </slide>

        <slide class="slide">
            <div class="row items-center">
                <div class="media-image col-lg-2 text-center flex justify-around">
                    <img class="" src="/static/img/logo/homepage/legiteam.png" style="width: 140px;" />
                </div>
                <div class="col-lg-8">
                    <p class="fw-bold italic">
                    <span class="shrink-5 lg:shrink-3 leading-5">«&nbsp;</span>
                    Avec la plateforme française Octolo, dématérialisez et automatisez votre secrétariat juridique corporate.
                    Trois principaux services : Table de capitalisation, répertoires, alertes Création et tenue en ligne ou en hybride des instances...
                    <span class="shrink-3 leading-5">&nbsp;»&nbsp;</span>
                    <a target="_blank" href="https://www.jurishop.fr/Octolo-10629">{{ gettext("Voir l'article") }}</a>
                    </p>
                    <small>{{ gettext("Legiteam") }}</small>
                </div>
            </div>
        </slide>

        <template #addons>
            <navigation />
            <pagination />
        </template>

    </carousel>

</section>
</template>

<script>
import 'vue3-carousel/dist/carousel.css'
import { Carousel, Slide, Pagination, Navigation } from 'vue3-carousel'

export default {
    components: {
        Carousel,
        Slide,
        Pagination,
        Navigation
    },
    data() {
        return {
        slide: 0
        }
    }
}
</script>

<style lang="scss">
@import "@/assets/vars.scss";

.carousel__slide {
  padding: 50px;
}

.carousel__prev,
.carousel__next {
    background: transparent;
    border: none;
    color: $octo-primary;
    cursor: pointer;
    font-size: 24px;
    transition-duration: 0.3s;
}

.carousel__prev:hover,
.carousel__next:hover {
    color: $octo-secondary;
}
</style>
